import { UnknownAction } from "@reduxjs/toolkit";

import {
    ACCESS_INTERVAL,
    ACCESS_TOKEN,
    REFRESH_INTERVAL,
    REFRESH_TOKEN,
    ROUTES,
    TOKEN_EXPIRY_KEY,
} from "@/constants";
import { logoutResetApp } from "@/store/actions";

let isLoggingOut = false;

type Deps = {
    dispatch: (action: UnknownAction) => void;
    flushPersistor: () => Promise<void>;
};

let deps: Deps | null = null;

export const configureLogoutService = (d: Deps) => {
    deps = d;
};

const clearAuthStorage = () => {
    localStorage.removeItem(ACCESS_TOKEN);
    localStorage.removeItem(REFRESH_TOKEN);
    localStorage.removeItem(TOKEN_EXPIRY_KEY);
    localStorage.removeItem(ACCESS_INTERVAL);
    localStorage.removeItem(REFRESH_INTERVAL);
};

export const logoutService = async () => {
    if (isLoggingOut) return;

    if (!deps) throw new Error("logoutService deps not configured");

    isLoggingOut = true;

    try {
        clearAuthStorage();

        deps.dispatch(logoutResetApp());
        await deps.flushPersistor();

        const keys = await caches.keys();
        await Promise.all(keys.map((k) => caches.delete(k)));

        window.location.replace(ROUTES.Login);
    } finally {
        isLoggingOut = false;
    }
};
